import React from "react";
import NotFound from "../notFound/NotFound";
import UserChangeInfoTemplate from "./components/templates/UserChangeInfoTemplate";

export default function UserChangeInfo() {
  const adminFlag = localStorage.getItem("adminFlag");
  const isValidAdmin = adminFlag !== null && Number(adminFlag) !== -1;

  return <div>{isValidAdmin ? <UserChangeInfoTemplate /> : <NotFound />}</div>;
}